import { path } from "../utils";
import { WilliamsAD as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { useVolume, volumePath } = options;

    if (!data || data.length < 2) {
      return Array(data.length).fill(undefined);
    }

    const getVolume = path(volumePath);
    const result = new Array(data.length);
    result[0] = undefined; // First value is undefined (needs previous bar)

    let total = 0;

    for (let i = 1; i < data.length; i++) {
      const current = data[i];
      const previous = data[i - 1];

      // Skip if missing required data
      if (
        !current ||
        !previous ||
        current.close == null ||
        previous.close == null ||
        current.high == null ||
        current.low == null
      ) {
        result[i] = undefined;
        continue;
      }

      let dailyAD = 0;

      if (current.close > previous.close) {
        // Buying pressure: close - min(low, prev_close)
        dailyAD = current.close - Math.min(current.low, previous.close);
      } else if (current.close < previous.close) {
        // Selling pressure: close - max(high, prev_close)
        dailyAD = current.close - Math.max(current.high, previous.close);
      }
      // If close === prev_close, dailyAD remains 0

      // Optionally multiply by volume
      if (useVolume) {
        const volumeValue = Number(getVolume(current));
        if (Number.isFinite(volumeValue)) {
          dailyAD *= volumeValue;
        }
      }

      // Accumulate
      total += dailyAD;
      result[i] = total;
    }

    return result;
  }

  calculator.undefinedLength = function () {
    return 1; // First bar is undefined
  };

  calculator.options = function (x) {
    if (!arguments.length) return options;
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
